import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RoofTileFactoryBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.ROOF_TILE_FACTORY;
}

export default RoofTileFactoryBuildingTileEntity;
